import request from "@/api/config.js";

export function NotificationTGCreate(data) {
  return request({
    url: `notification/tg/new`,
    method: "post",
    data,
  });
}

export function NotificationTGRemove(data) {
  return request({
    url: `notification/tg/remove`,
    method: "post",
    data,
  });
}

export function NotificationTGList(education_id) {
  return request({
    url: `notification/tg-list/${education_id}`,
    method: "get",
  });
}
